module.exports = __webpack_public_path__ + "static/media/eel.57250630.webp";